
import Card from "@/components/base/card/Card"
import { Search } from "@/models/search"
import { routeToJobList } from "@/helpers/routing"
export default {
    name: "ListCard",
    components: { Card },
    props: {
        item: {
            type: Object,
            required: true,
        },
        location: {
            type: Object,
            default: undefined,
        },
        imageFormat: {
            type: String,
            default: "1",
        },
        minHeight: {
            type: String,
            default: "130px",
        },
    },
    data() {
        return {
            showModal: false,
            listSearch: null,
            routeToJobList,
        }
    },
    computed: {
        imageSrc() {
            return this.$getImage({
                image: this.item.image,
                preferedSize: this.imageFormat,
            }).src
        },
        listCardStyles() {
            return {
                minHeight: this.minHeight,
            }
        },
    },
    methods: {
        initSearch() {
            this.listSearch = new Search({
                type: "apprenticeship",
                location: this.location,
                distance: 5000,
                list: this.item.slug,
            })
        },
    },
}
